import './PageContainer.css';

const PageContainer = ({children}) => {
	return (
		<div id="screen-container">
			<div id="width-container">
				<div id="page-container">
					<div id="inner-page-container">
						{children}
					</div>
				</div>
			</div>
		</div>
	);
};

export default PageContainer;
